import { PACKING_RULES_SELECTION } from '@/js/constants/packing-rules';

export class PackageStruct {
    constructor({ id, packing_rule_id, sku, name, item_type, length, width, height, weight, weight_limit, quantity, quantity_limit }) {
        this.id = id || '';
        this.packing_rule_id = packing_rule_id || '';
        this.sku = sku || '';
        this.name = name || '';
        this.item_type = item_type || 'Carton';
        this.length = length || '';
        this.width = width || '';
        this.height = height || '';
        this.weight = weight || '';
        this.weight_limit = weight_limit || '';
        this.quantity = quantity || '';
        this.quantity_limit = quantity_limit || '';
    }
}

export default class PackingRuleStruct {
    constructor({ id, integration_id, enabled, label, description, target,  rule_conditions, products_to_pack, packing_method, packages, options, order }) {
        this.id = id || '';
        this.integration_id = integration_id || '';
        this.enabled = enabled ?? true;
        this.label = label || '';
        this.description = description || '';
        this.target = target || 'unpacked';
        this.rule_conditions = rule_conditions || [];
        this.products_to_pack = products_to_pack || PACKING_RULES_SELECTION.MATCHED.value;
        this.packing_method = packing_method || 'individual-packing';
        this.packages = Array.isArray(packages) ? packages.map(pkg => new PackageStruct(pkg)) : [new PackageStruct(packages || {})];
        this.options = options || {};
        this.order = order || 0;
    }
}